/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useRef, useState } from "react";
// @mui material components

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
// Material Dashboard 2 PRO React examples
// import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// import DashboardNavbar from "examples/Navbars/DashboardNavbar";
// import Footer from "examples/Footer";
import grapesjs from "grapesjs";
// import GjsEditor from "@grapesjs/react";
import customCodePlugin from "layouts/pages/utils/custom-code-grapejs/index.ts";
// import sendpadForm from "layouts/pages/utils/sendpadForm/index.ts";
import gjsTabs from "layouts/pages/utils/grapeJsTabs/index";
import gjsImageEditor from "layouts/pages/utils/grapeJsImageEditor/index.ts";
import gjsTooltip from "grapesjs-tooltip";
import gjsp from "grapesjs-preset-webpage";
import gjsModal from "layouts/pages/utils/grapejsModal/index.ts";
import gjsAccordian from "grapesjs-accordion";
import alignment from "layouts/pages/customstyles/alignment.js";
import placeholder from "layouts/pages/utils/grapesJSPlaceholder/index.js";
import { utils } from "../pages/utils/index";
import { updateBlocks } from "../pages/blocks/updateblocks";
import { newBlocks } from "../pages/blocks/newblocks";
import { sidebarPannel } from "../pages/panels/sidebarpanel";
import { grapeJsEvents } from "../pages/events/grapeJsEvents";
import { ExpandText } from "../pages/components/expandText";
import { ImageAI } from "../pages/components/imageAI";
import { SendPadForm } from "../pages/components/sendPadForm.js";
import myNewComponentTypes from "../pages/components/grapejscomponents/index.ts";
import { NextPageButton } from "../pages/components/nextPageButton";

import client from "ApiClient";
import { CircularProgress, Dialog, DialogContent, DialogActions } from "@mui/material";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import Settingsidebar from "layouts/pages/panels/settingsidebar";
import MDSnackbar from "components/MDSnackbar";
import ConfirmationAlert from "components/ConfirmationAlert";
import SimpleReactValidator from "simple-react-validator";
import tiny_mce from "layouts/pages/tiny_mce";
import Templates from "./components/templates";
import replaceTextViewComponent from "layouts/pages/utils/single-click-tinymce";
import { ExpandHeading } from "layouts/pages/components/expandHeading";

function Page(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [openSettingSaved, setOpenSettingSaved] = useState(false);
  const [showClose, setShowClose] = useState(false);
  const [openConfirmationClose, setOpenConfirmationClose] = useState(false);
  const [savingOpen, setSavingOpen] = useState(false);
  const closeSettingSaved = () => setOpenSettingSaved(false);
  const [settingSidebarOpen, setSettingSidebarOpen] = useState(false);
  const [grapeEditor, setGrapeEditor] = useState(null);
  const [pageId, setPageId] = useState(null);
  const [selectedPage, setSelectedPage] = useState(null);
  const [loadingText, setLoadingText] = useState("Loading ...");

  const [pageTitle, setPageTitle] = useState("");
  const [faviconUrl, setFaviconUrl] = useState("");
  const [bgImageUrl, setBgImageUrl] = useState("");
  const [pagKeywords, setPagKeywords] = useState("");
  const [pagSlug, setPagSlug] = useState("");
  const [pagDescription, setPagDescription] = useState("");
  const [pagGoogleConversionID, setPagGoogleConversionID] = useState("");
  const [pagGoogleConversionLabel, setPagGoogleConversionLabel] = useState("");
  const [pagGoogleMetaTag, setPagGoogleMetaTag] = useState("");
  const [pagGoogleAnalyticsID, setPagGoogleAnalyticsID] = useState("");
  const [pagMSVerificationTag, setPagMSVerificationTag] = useState("");
  const [pagMSUETTagID, setPagMSUETTagID] = useState("");
  const [pagCustomHead, setPagCustomHead] = useState("");
  const [pagCustomBody, setPagCustomBody] = useState("");
  const [pagCustomFooter, setPagCustomFooter] = useState("");
  const [pageName, setPageName] = useState("");
  const [openPageName, setOpenPageName] = useState(false);
  const [sendpadForms, setSendpadForms] = useState([]);

  const [openTemplates, setOpenTemplates] = useState(false);
  const [openPageTitle, setOpenPageTitle] = useState(props.page ? false : true);

  const [draftLoading, setDraftLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const [, forceUpdate] = useState();
  const simpleValidator = useRef(new SimpleReactValidator());

  const { images } = props;

  const options = {
    method: "GET",
    url: "pages",
    headers: {
      "content-type": "application/json",
    },
  };

  const editorPanel = useRef(null);
  const optionsPanel = useRef(null);

  useEffect(() => {
    if (savingOpen) save();
  }, [savingOpen]);

  const updateSettings = (seoTitle, seoKeyword, seoDescription, seoSlug) => {
    setIsLoading(true);
    setPageTitle(seoTitle);
    setPagSlug(seoSlug);
    setPagDescription(seoDescription);
    setPagKeywords(seoKeyword);

    options.method = "PUT";
    options.url = `pages`;

    const data = grapeEditor.getProjectData();
    const html = grapeEditor.getHtml();
    const css = grapeEditor.getCss();

    options.data = JSON.stringify({
      pag_fun_id: selectedPage.pag_fun_id,
      pag_id: selectedPage.pag_id,
      pag_name: selectedPage.pag_name,
      pag_creationDate: selectedPage.pag_creationDate,
      pag_status: selectedPage.pag_status,
      pag_user_id: selectedPage.pag_user_id,
      pag_url: selectedPage.pag_url,
      pag_html: html,
      pag_css: css,
      pag_json: JSON.stringify(data),
      pag_version: 1,
      pag_title: seoTitle,
      pag_slug: seoSlug,
      pag_description: seoDescription,
      pag_keywords: seoKeyword,
      pag_favicon: faviconUrl,
      pag_googleConversionID: pagGoogleConversionID,
      pag_googleConversionLabel: pagGoogleConversionLabel,
      pag_googleMetaTag: pagGoogleMetaTag,
      pag_googleAnalyticsID: pagGoogleAnalyticsID,
      pag_MSVerificationTag: pagMSVerificationTag,
      pag_MSUETTagID: pagMSUETTagID,
      pag_customHead: pagCustomHead,
      pag_customBody: pagCustomBody,
      pag_customFooter: pagCustomFooter,
      pag_bgImageURL: bgImageUrl,
    });

    client
      .request(options)
      .then((response) => {
        setIsLoading(false);
        if (response === undefined) {
          setLoadingText("Slug already exists");
        } else {
          setSelectedPage(response);
          setOpenSettingSaved(true);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
      });
  };

  const updateScript = (
    googleConversionId,
    conversionLabel,
    googleMetaTag,
    googleAnalyticsId,
    msSiteVerificationTag,
    msUetTagId,
    headScript,
    bodyScript,
    footerScript
  ) => {
    setIsLoading(true);
    setPagGoogleAnalyticsID(googleAnalyticsId);
    setPagGoogleConversionID(googleConversionId);
    setPagGoogleConversionLabel(conversionLabel);
    setPagGoogleMetaTag(googleMetaTag);
    setPagMSVerificationTag(msSiteVerificationTag);
    setPagMSUETTagID(msUetTagId);
    setPagCustomHead(headScript);
    setPagCustomBody(bodyScript);
    setPagCustomFooter(footerScript);

    options.method = "PUT";
    options.url = `pages`;

    const data = grapeEditor.getProjectData();
    //const html = grapeEditor.Commands.run("gjs-get-inlined-html"); // grapeEditor.getHtml();
    const html = grapeEditor.getHtml();
    const css = grapeEditor.getCss();
    // console.log("pageTitle", title, slug, favicon);

    options.data = JSON.stringify({
      pag_fun_id: selectedPage.pag_fun_id,
      pag_id: selectedPage.pag_id,
      pag_name: selectedPage.pag_name,
      pag_creationDate: selectedPage.pag_creationDate,
      pag_status: selectedPage.pag_status,
      pag_user_id: selectedPage.pag_user_id,
      pag_url: selectedPage.pag_url,
      pag_html: html,
      pag_css: css,
      pag_json: JSON.stringify(data),
      pag_version: 1,
      pag_title: pageTitle,
      pag_slug: pagSlug,
      pag_description: pagDescription,
      pag_keywords: pagKeywords,
      pag_googleConversionID: googleConversionId,
      pag_googleConversionLabel: conversionLabel,
      pag_googleMetaTag: googleMetaTag,
      pag_googleAnalyticsID: googleAnalyticsId,
      pag_MSVerificationTag: msSiteVerificationTag,
      pag_MSUETTagID: msUetTagId,
      pag_customHead: headScript,
      pag_customBody: bodyScript,
      pag_customFooter: footerScript,
      pag_bgImageURL: bgImageUrl,
      pag_favicon: faviconUrl,
    });

    client
      .request(options)
      .then((response) => {
        setIsLoading(false);
        if (response === undefined) {
          setLoadingText("Slug already exists");
        } else {
          setSelectedPage(response);
          setOpenSettingSaved(true);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
      });
  };

  const save = async () => {
    setIsSaving(true);
    setLoadingText("");
    options.method = "PUT";
    options.url = `pages`;

    const data = grapeEditor.getProjectData();
    //const html = grapeEditor.Commands.run("gjs-get-inlined-html"); // grapeEditor.getHtml();
    const html = grapeEditor.getHtml();
    const css = grapeEditor.getCss();
    const hasNextPage = html.includes("[NEXT_PAGE]");

    if (!hasNextPage)
      setLoadingText(
        "A 'Next Page' button was not detected. Please add a 'Next Page' button from the form widgets to connect to the next page. If this is the last page in your funnel, you can ignore this message"
      );

    options.data = JSON.stringify({
      pag_fun_id: selectedPage.pag_fun_id,
      pag_id: selectedPage.pag_id,
      pag_creationDate: selectedPage.pag_creationDate,
      pag_status: selectedPage.pag_status,
      pag_user_id: selectedPage.pag_user_id,
      pag_url: selectedPage.pag_url,
      pag_name: pageName,
      pag_version: selectedPage.pag_version,
      pag_slug: selectedPage.pag_slug,
      pag_favicon: selectedPage.pag_favicon,
      pag_html: html,
      pag_css: css,
      pag_json: JSON.stringify(data),
      pag_title: pageTitle,
      pag_slug: pagSlug,
      pag_bgImageURL: bgImageUrl,
      pag_favicon: faviconUrl,
      pag_description: pagDescription,
      pag_keywords: pagKeywords,
      pag_googleConversionID: pagGoogleConversionID,
      pag_googleConversionLabel: pagGoogleConversionLabel,
      pag_googleMetaTag: pagGoogleMetaTag,
      pag_googleAnalyticsID: pagGoogleAnalyticsID,
      pag_MSVerificationTag: pagMSVerificationTag,
      pag_MSUETTagID: pagMSUETTagID,
      pag_customHead: pagCustomHead,
      pag_customBody: pagCustomBody,
      pag_customFooter: pagCustomFooter,
    });

    client
      .request(options)
      .then((response) => {
        setSelectedPage(response);
        setIsSaving(false);
        if (hasNextPage) setSavingOpen(false);
        else setShowClose(true);
        const pageNameEditor = grapeEditor.Panels.getButton("myNewPanel", "PageName");
        pageNameEditor.set(
          "label",
          ` 
        <span

         class="badge badge-primary" style="cursor: default;">
         
          <span  class="px-2"> ${response.pag_name}   <i class="fa fa-pencil ps-2"> </i></span>
                                 
        </span>
      `
        );
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getFroms = async () => {
    options.method = "GET";
    options.url = `forms`;
    await client
      .request(options)
      .then((response) => {
        let form = [];
        response.map((item) => {
          form.push({
            id: item.name,
            name: item.name,
            value: item.html,
          });
        });
        setSendpadForms(form);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    // setHideSidenav(dispatch, true);
    if (JSON.parse(localStorage.getItem("settings")).set_msApiKey != "") getFroms();
    /*
    return () => {
      setHideSidenav(dispatch, false);
    };*/
  }, []);

  const addNewPage = () => {
    if (props.page) {
      setPageId(props.page.pag_id);
      setSelectedPage(props.page);
    } else {
      if (simpleValidator.current.allValid()) {
        setIsLoading(true);
        setLoadingText("");
        options.method = "POST";
        options.url = `pages`;

        options.data = JSON.stringify({
          pag_status: 3,
          pag_user_id: 0,
          pag_name: pageTitle,
          pag_fun_id: props.funnel.fun_id,
          pag_url: "",
          pag_html: "",
          pag_css: "",
          pag_json: "",
          pag_title: pageTitle,
          pag_version: 1,
          pag_slug: pageTitle.replace(/\s/g, "-").toLowerCase(),
          pag_favicon: null,
          pag_bgImageURL: null,
          pag_description: "",
          pag_keywords: "",
          pag_googleConversionID: "",
          pag_googleConversionLabel: "",
          pag_googleMetaTag: "",
          pag_googleAnalyticsID: "",
          pag_MSVerificationTag: "",
          pag_MSUETTagID: "",
          pag_customHead: "",
          pag_customBody: "",
          pag_customFooter: "",
          pag_totalVisits: 0,
          pag_ff_account_id: 0,
          pag_ff_page_id: 0,
        });

        client
          .request(options)
          .then((response) => {
            setSelectedPage(response);
            setPageId(response.pag_id);
            setOpenPageTitle(false);
          })
          .catch((error) => {
            console.log("ERROR", error);
            // setIsSaving(false);
          });
      } else {
        simpleValidator.current.showMessages();
        forceUpdate(1);
      }
    }
  };

  const getPageById = (id) => {
    options.method = "GET";
    options.url = `pages/byid?page_id=${id}`;
    client
      .request(options)
      .then((response) => {
        setOpenTemplates(false);
        selectedPage.pag_json = response.pag_json;
        selectedPage.pag_html = response.pag_html;
        selectedPage.pag_css = response.pag_css;
        setPageName(response.pag_name);

        grapeEditor.loadProjectData(JSON.parse(response.pag_json));
        grapeEditor.UndoManager.clear();
        const pageNameEditor = grapeEditor.Panels.getButton("myNewPanel", "PageName");
        pageNameEditor.set(
          "label",
          ` 
        <span

         class="badge badge-primary" style="cursor: default;">
         
          <span  class="px-2"> ${response.pag_name}   <i class="fa fa-pencil ps-2"> </i></span>
                                 
        </span>
      `
        );
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    setPageTitle(props.page?.pag_title);
    setFaviconUrl(props.page?.pag_favicon);
    setPagSlug(props.page?.pag_slug);
    setBgImageUrl(props.page?.pag_bg_image);
    setPagKeywords(props.page?.pag_keywords);
    setPagDescription(props.page?.pag_description);
    setPagGoogleConversionID(props.page?.pag_googleConversionID);
    setPagGoogleConversionLabel(props.page?.pag_googleConversionLabel);
    setPagGoogleMetaTag(props.page?.pag_googleMetaTag);
    setPagGoogleAnalyticsID(props.page?.pag_googleAnalyticsID);
    setPagMSVerificationTag(props.page?.pag_MSVerificationTag);
    setPagMSUETTagID(props.page?.pag_MSUETTagID);
    setPagCustomHead(props.page?.pag_customHead);
    setPagCustomBody(props.page?.pag_customBody);
    setPagCustomFooter(props.page?.pag_customFooter);
  }, [props]);

  useEffect(() => {
    if (!openPageTitle && !isLoading) addNewPage();
    else if (isLoading) setIsLoading(false);
  }, [openPageTitle]);

  useEffect(() => {
    if (pageId == null) return;
    if (
      JSON.parse(localStorage.getItem("settings")).set_msApiKey != "" &&
      JSON.parse(localStorage.getItem("settings")).set_msApiKey != null &&
      sendpadForms == null
    )
      return;
    initEditor(pageId);
  }, [sendpadForms, pageId]);

  const initEditor = (pagId) => {
    setIsLoading(true);
    const plugins = [
      gjsAccordian,
      gjsImageEditor,
      gjsp,
      gjsTabs,
      gjsTooltip,
      ImageAI,
      ExpandText,
      ExpandHeading,
      gjsModal,
      alignment,
      tiny_mce,
      customCodePlugin,
      NextPageButton,
      placeholder,
      myNewComponentTypes,
    ];
    if (
      JSON.parse(localStorage.getItem("settings")).set_msApiKey != "" &&
      JSON.parse(localStorage.getItem("settings")).set_msApiKey != null
    )
      plugins.push(SendPadForm);

    const editor = grapesjs.init({
      allowScripts: 1,
      modal: {
        backdrop: false,
      },
      storageManager: false,
      container: "#gjs",
      height: "100vh",
      fromElement: true,
      styleManager: {
        sectors: [
          {
            name: "Dimension",
            open: false,
            properties: ["width", "height", "max-width", "min-height", "margin", "padding"],
          },
          {
            name: "Flex",
            open: false,
            properties: [
              "flex-direction",
              "flex-wrap",
              "justify-content",
              "align-items",
              "align-content",
              "order",
              "flex-basis",
              "flex-grow",
              "flex-shrink",
              "align-self",
            ],
          },
          {
            name: "Alignment",
            properties: [
              {
                type: "my-custom-prop",
                property: "text-align",
                default: "center",
              },
            ],
          },
        ],
      },
      canvasCss: `
          a:link { 
            text-decoration: none; 
          }
          gjs-plh-image{
              color:#3b97e3;
          }
          .image-pl-svg{
              fill:#3b97e3;
          }
          .gjs-plh-image[data-gjs-type="image"]{
              width:30%;
              height:30%;
              background-color:transparent;
              outline:none;
  
          }
        
          div.navbar[data-gjs="navbar"]{
              max-width:100%;
  
          }
          div.navbar[data-gjs="navbar"]>.navbar-container{
              max-width:1140px;
          }
         
  
          .gjs-selected{
              outline: 4px solid #3b97e3 !important;
              outline-offset: -2px;
          }
          img.gjs-selected{
              z-index: 90000001;
              position: relative;
          }
          .gjs-higlight-backdrop-container{
              position: absolute;
              width: 100%;
              height: 100%;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background-color: #151515;
              z-index:9000000;
              opacity:0;
              transition: opacity 0.3s ease-in
          }
          .gjs-higlight-backdrop-container.active{
              opacity:0.3;
          }
  
          .form-group {
              width: 100%;
          }
  
          .form-group {
              width: 100%;
          }
          [data-gjs-type="grid-item"]:empty {
              overflow: hidden;
              text-decoration: none;
              padding: 5px;
              display: flow;
      width: 99%;
          }
          .cell{
            height: auto !important;
          }
          [data-gjs-type="grid-item"]:empty:before {
              background-color: #ddd;
              color: #000;
              font-size: 16px;
              font-weight: bold;
              height: 75px;
              display: flex;
              align-items: center;
              justify-content: center;
              min-height: 50px;
              padding: 0 10px;
              opacity: 0.3;
              border-radius: 3px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              content: "Column";
          }   
          .gjs-row,.row{display:flex;justify-content:flex-start;align-items:stretch;flex-wrap:nowrap;padding:10px;min-height:75px;flex-direction:row}@media (max-width:768px){.gjs-row,.row{flex-wrap:wrap; flex-direction: column;gap: 10px;}}.cell,.cell-gut,.gjs-cell,.gjs-cell-gut{flex-grow:1;flex-basis:100%;padding:5px}.cell-gut,.gjs-cell-gut{padding-right:15px}@media (max-width:768px){.cell-gut,.gjs-cell-gut{padding-right:0}}@media (max-width:768px){.burger{display:block}}
  
        `,
      protectedCss: `body{margin:0; }.row{margin:0 auto;box-sizing:border-box;} div.row>div.cell:first-child{
              padding-right:6px;
              padding-left:0px;
          }div.row>div.cell:last-child{
              padding-left:6px;
              padding-right:0px;
          }div.cell{
              padding-left:3px;
              padding-right:3px;
          } 
          .cell{
            height: auto !important;
          }
          .right-space-issue {
    margin-right: 3rem;
  } @media (max-width: 768px){       .right-space-issue {
    margin-right: 0;
  }}
          .openModalBtn{border: none; cursor: pointer; background-color: #f0c864; color: #000;font-weight: 700; line-height: 1.66; font-size: 20px; border: 0; border-radius: 30px; display: inline-block; padding: 8px 20px; width: auto; height: 48px;} .modal{z-index:11111; position:relative;} .accordion-content{font-family:inherit; font-size: 16px;line-height: 1.5;color: #0e0e0e;border: none !important;min-height: 40px !important;}.closeModalBtn {cursor: pointer;}.accordion{font-family:inherit !important; font-size: 22px;font-weight: 700;line-height: 1.18;color: #111;margin-bottom: 8px;cursor: pointer;background: none !important;border: none;text-decoration:none;} a.accordion::before{content: '+';margin-right: 8px;}.accordion-active a.accordion::before {content: '–';}img{max-width:100%;height:auto}.cell {height: auto;vertical-align: top;}.cke_editable p{display: block; margin-block-start: 0em !important; margin-block-end: 0em !important;margin-inline-start: 0em !important;margin-inline-end: 0em !important;}table.grid-item-card tbody tr td {background: none !important;}.list-item tr td {background: none !important;}.form-group{ float:none; flex-direction:column; border:0 solid black; display:flex; } .label{ margin:0 0 15px 0; font-family:Arial, Helvetica, sans-serif; font-size:14px; font-weight:600; } .form{ display:flex; flex-direction:column; padding:50px 50px 50px 50px; border:1px solid #6c7978; margin:10px 10px 10px 10px; background-color:#f5f5f5; } .input{ height:40px; width:auto; margin:0 0 15px 0; border-radius:7px; border:1px solid #9e9e9e; padding:0 10px 0 10px; } textarea { margin:0 0 15px 0; border-radius:7px; border:1px solid #9e9e9e; padding:0 10px 0 10px;} .button{ height:42px; border-radius:7px; margin:10px 0 0 0; border:1px solid #7e7e7e; font-family:Arial Black, Gadget, sans-serif; font-size:14px; font-weight:600; color:#ffffff; background-color:#000000; } .form-group:nth-child(3) {display: none;} .form-group:nth-child(4) {display: none;}.form-group:has(> .checkbox) { flex-direction:row;align-items: start; }input.checkbox {margin-left: 25px;}label.checkbox-label {margin-left: 5px;} @media (max-width: 992px){ .form{ padding:20px 20px 20px 20px; } }@media (max-width:768px){.cell{width:100%;}div.row>div.cell:first-child{
              padding-right:0px;
              padding-left:0px;
          }div.row>div.cell:last-child{
              padding-left:0px;
              padding-right:0px;
          } }
          .form-group {
              width: 100%;
          }
          .gjs-row,.row{display:flex;justify-content:flex-start;align-items:stretch;flex-wrap:nowrap;padding:10px;min-height:75px;flex-direction:row}@media (max-width:768px){.gjs-row,.row{flex-wrap:wrap; flex-direction: column;gap: 10px;}}.cell,.cell-gut,.gjs-cell,.gjs-cell-gut{flex-grow:1;flex-basis:100%;padding:5px}.cell-gut,.gjs-cell-gut{padding-right:15px}@media (max-width:768px){.cell-gut,.gjs-cell-gut{padding-right:0}}@media (max-width:768px){.burger{display:block}}
        .modal{z-index:11111; position:relative;} .accordion-content{font-family:inherit; font-size: 16px;line-height: 1.5;color: #0e0e0e;border: none !important;min-height: 40px !important;}.closeModalBtn {cursor: pointer;}.accordion{font-family:inherit !important; font-size: 22px;font-weight: 700;line-height: 1.18;color: #111;margin-bottom: 8px;cursor: pointer;background: none !important;border: none;text-decoration:none;}a.accordion::before{content: '+';margin-right: 8px;}.accordion-active a.accordion::before {content: '–';}.row{padding:0 !important;}p{padding:0 !important; margin:0 !important;}h1{padding:0 !important; margin:0 !important;}h4{padding:0; margin:0;}@media(max-width:768px){.cell{display: block !important; width: 100% !important; height: auto !important; padding: 0 !important; min-height: 75px !important; }}.accordion>p{display:inline-block;}           
         `,
      width: "100%",
      plugins: plugins,
      pluginsOpts: {
        [gjsp]: {
          blocks: [],
          showStylesOnChange: false,
          // options
        },
        customCodePlugin: {
          placeholderScript: true,
          blockCustomCode: { label: "Custom" },
          // options
        },
        [tiny_mce]: {
          "tinymce-module": "/tinymce/tinymce.min.js",
          inline: ["span", "a", "button"],
          inline_toolbar: [
            "bold italic underline strikethrough forecolor | alignleft aligncenter alignright alignfull",
          ],
          toolbar: [
            "bold italic underline strikethrough link outdent indent",
            "blocks forecolor backcolor | alignleft aligncenter alignright alignfull | numlist bullist",
          ],
          plugins: ["link", "lists", "autolink"],
        },
        [placeholder]: {
          dragDefault: [""],
          dragClasses: ["gjs-selected", "gjs-freezed", "animation"],
          animation: ["none"], // animation1 / animation2 / animation3 / animation4 / animation5 / none
        },

        [SendPadForm]: {
          forms: sendpadForms,
        },
      },
      clearOnRender: true,

      deviceManager: {
        devices: [
          {
            id: "desktop",
            name: "Desktop",
            width: "",
          },
          {
            id: "tablet",
            name: "Tablet",
            width: "768px",
            widthMedia: "992px",
          },
          {
            id: "mobilePortrait",
            name: "Mobile portrait",
            title: "Mobile portrait",
            width: "320px",
            widthMedia: "575px",
          },
        ],
      },
      assetManager: {
        assets: images,
        custom: false,
        upload: process.env.REACT_APP_API_BASE_URL + "/grapeai/uploadImageBin",
        multiUpload: false,
        headers: { Authorization: JSON.parse(localStorage.getItem("AuthorizationToken")) },
        autoAdd: 1,
      },
    });

    const panelManager = editor.Panels;

    panelManager.addPanel({
      id: "myNewPanel",
      buttons: [
        {
          id: "logo",
          className: "logo-editor",
          label: `<img src="https://thumbs.${process.env.REACT_APP_MAIN_DOMAIN}/images/pixapage-logot.png" alt="Logo" height="40">`,
        },
        {
          id: "backbtn",
          disabled: isLoading,
          command: {
            run: () => {
              setOpenConfirmationClose(true);
            },
          },
          className: " btnBack",
          label: `<button   class="ccc btn btn-secondary Mydropdowntoogle" style="color:#333;background-color: #FFF;cursor:pointer"> 
          <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 -960 960 960" width="24px" fill="#e8eaed"><path d="m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z"/></svg>
     <span class="px-2 fw-semibold"> ${draftLoading ? "loading" : "Close"}  <span>                
      </span> </span>
       </button>
  `,
        },
        {
          id: "savebtn",
          disabled: isLoading,
          command: {
            run: async () => {
              setSavingOpen(true);
            },
          },
          className: "fa-solid fa-floppy-disk",
          label: `<button   class="ccc btn btn-secondary Mydropdowntoogle" style="background-color: green;cursor:pointer"> 
                    <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 -960 960 960" width="24px" fill="#e8eaed"><path d="M840-680v480q0 33-23.5 56.5T760-120H200q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h480l160 160Zm-80 34L646-760H200v560h560v-446ZM480-240q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35ZM240-560h360v-160H240v160Zm-40-86v446-560 114Z"/></svg>
               <span class="px-2 fw-semibold"> ${
                 draftLoading ? "loading" : "Save"
               }  <span>                
                </span> </span>
                 </button>
            `,
        },
        {
          id: "cmdDeviceDesktop",
          command: (e) => e.setDevice("Desktop"),
          className: "fa fa-desktop",
          active: 1,
        },
        {
          id: "cmdDeviceTablet",
          command: (e) => e.setDevice("Tablet"),
          className: "fa fa-tablet",
        },
        {
          id: "cmdDeviceMobile",
          command: (e) => e.setDevice("Mobile portrait"),
          className: "fa fa-mobile",
        },
        {
          id: "PageName",
          label: `<span class="badge badge-primary" style="cursor: default;">
                    <span  class="px-2"> ${pageName}   <i class="fa fa-pencil ps-2"> </i></span>                                  
                  </span>`,
          active: 1,
          command: {
            run: () => {
              setOpenPageName(true);
            },
          },
        },
      ],
    });

    editor.on("load", () => {
      updateBlocks(editor);
      if (pagId) {
        options.method = "GET";
        options.url = `pages/byid?page_id=${pagId}`;
        client
          .request(options)
          .then((response) => {
            setSelectedPage(response);
            setPageName(response.pag_name);
            setPageTitle(response.pag_title);
            setFaviconUrl(response.pag_favicon);
            setPagSlug(response.pag_slug);
            setBgImageUrl(response.pag_bg_image);
            setPagKeywords(response.pag_keywords);
            setPagDescription(response.pag_description);
            setPagGoogleConversionID(response.pag_googleConversionID);
            setPagGoogleConversionLabel(response.pag_googleConversionLabel);
            setPagGoogleMetaTag(response.pag_googleMetaTag);
            setPagGoogleAnalyticsID(response.pag_googleAnalyticsID);
            setPagMSVerificationTag(response.pag_MSVerificationTag);
            setPagMSUETTagID(response.pag_MSUETTagID);
            setPagCustomHead(response.pag_customHead);
            setPagCustomBody(response.pag_customBody);
            setPagCustomFooter(response.pag_customFooter);
            if (response.pag_json != "") editor.loadProjectData(JSON.parse(response.pag_json));
            else setOpenTemplates(true);
            editor.UndoManager.clear();
            const pageNameEditor = editor.Panels.getButton("myNewPanel", "PageName");
            pageNameEditor.set(
              "label",
              ` 
            <span
    
             class="badge badge-primary" style="cursor: default;">
             
              <span  class="px-2"> ${response.pag_name}   <i class="fa fa-pencil ps-2"> </i></span>
                                     
            </span>
          `
            );
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            setIsLoading(false);
          });
      } else {
        setIsLoading(false);
        setOpenTemplates(true);
        // console.log("OPEN TEMPLATES");
      }
    });

    editor.on("asset:remove", (asset) => {
      deleteImages(asset.attributes);
    });

    newBlocks(editor);

    editor.Panels.removeButton("options", "undo");
    editor.Panels.removeButton("options", "redo");
    panelManager.addButton("options", [
      {
        id: "undo",
        className: "fa fa-undo icon-undo",
        command: function (editor, sender) {
          //console.log("sender", sender);
          if (editor.UndoManager.hasUndo()) {
            editor.UndoManager.undo();
            //sender.set("active", 0);
          }
        },
        attributes: {
          title: "Undo (CTRL/CMD + Z)",
        },
      },
      {
        id: "redo",
        className: "fa fa-repeat icon-redo",
        command: function (editor, sender) {
          //console.log("hasRedo", editor.UndoManager.hasRedo());
          if (editor.UndoManager.hasRedo()) {
            editor.UndoManager.redo();
            // sender.set("active", 0);
          }
        },
        attributes: {
          title: "Redo (CTRL/CMD + Y)",
        },
      },
    ]);

    editor.on("modal:open", (asset) => {
      editorPanel.current = panelManager.getPanel("myNewPanel");
      optionsPanel.current = panelManager.getPanel("options");
      panelManager.removePanel("options");
      panelManager.removePanel("myNewPanel");
    });

    editor.on("modal:close", (asset) => {
      panelManager.addPanel(optionsPanel.current);
      panelManager.addPanel(editorPanel.current);
    });

    sidebarPannel({ editor, settingSidebarOpen, setSettingSidebarOpen });
    // seoPannel({ editor, page, toast, setUpdateGrapeJs, updateGrapeJs });
    grapeJsEvents(editor);
    utils(editor);
    alignment(editor);
    replaceTextViewComponent(editor);
    setGrapeEditor(editor);

    const importScss = async () => {
      const scssModule = await import("../pages/grapejs_v1.scss");
      //  console.log(scssModule);
      return scssModule.default;
    };

    let linkTag;
    importScss().then((scssHref) => {
      // Create a new <link> tag
      //console.log(scssHref);
      linkTag = document.createElement("link");
      linkTag.rel = "stylesheet";
      linkTag.href = scssHref; //`http://${process.env.REACT_APP_MAIN_DOMAIN}/grapejs_v1.scss`;
      document.head.appendChild(linkTag);
    });

    // Cleanup function to unload CSS when the component unmounts
    return () => {
      if (linkTag) {
        document.head.removeChild(linkTag);
      }
    };
  };

  const closePage = () => {
    setOpenPageTitle(false);
    setIsLoading(false);
    setSavingOpen(false);
    props.onDone(null);
  };

  const verifiNextPage = () => {
    if (grapeEditor) {
      const html = grapeEditor.getHtml();
      if (!html.includes("[NEXT_PAGE]"))
        return "A 'Next Page' button was not detected. Please add a 'Next Page' button from the form widgets to connect to the next page. If this is the last page in your funnel, you can ignore this message";
      else return "";
    } else return "";
  };

  const changePageName = (value) => {
    setPageName(value);
  };

  const renderSnackBar = (
    <MDSnackbar
      color="success"
      icon="save"
      title="Setting saved"
      dateTime=""
      open={openSettingSaved}
      onClose={closeSettingSaved}
      close={closeSettingSaved}
      backgroundcolor={"error"}
    />
  );

  return (
    <>
      <ConfirmationAlert
        openModal={openConfirmationClose}
        isLoading={isLoading}
        title={
          <MDBox>
            <MDBox>
              Are you sure you want to close the page? Any unsaved changes will be lost.
            </MDBox>
            <MDBox>
              <MDTypography variant="body2">{verifiNextPage()}</MDTypography>{" "}
            </MDBox>
          </MDBox>
        }
        onYes={() => props.onDone(selectedPage)}
        onClose={() => setOpenConfirmationClose(false)}
      />
      <Dialog
        open={openPageTitle}
        onClose={(e, reason) => reason != "backdropClick" ?? closePage()}
      >
        <MDBox
          variant="gradient"
          bgColor="secondary"
          coloredShadow="secondary"
          mt={-1}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h6" fontWeight="medium" color="white" mt={1}>
            Page name
          </MDTypography>
        </MDBox>
        <DialogContent>
          <MDInput
            disabled={isLoading}
            style={{ padding: 10 }}
            type="text"
            label="Page name"
            fullWidth
            value={pageTitle}
            onChange={(e) => setPageTitle(e.target.value)}
            required
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                addNewPage();
              }
            }}
          />
          <MDBox color="red">
            {simpleValidator.current.message("Page Title", pageTitle, "required")}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            disabled={isLoading}
            onClick={() => closePage()}
            variant="outlined"
            color="secondary"
          >
            Cancel
          </MDButton>
          <MDButton
            disabled={isLoading}
            onClick={() => {
              addNewPage();
            }}
            color="success"
          >
            Create
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openPageName}>
        <MDBox
          variant="gradient"
          bgColor="secondary"
          coloredShadow="secondary"
          mt={-1}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h6" fontWeight="medium" color="white">
            Set page name
          </MDTypography>
        </MDBox>
        <DialogContent>
          <MDInput
            autofocus
            type={"text"}
            label="Page Name"
            value={pageName}
            onChange={(e) => changePageName(e.target.value)}
            fullWidth
            style={{ marginBottom: 20 }}
          />
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenPageName(false);
            }}
            variant="outlined"
            color="secondary"
            disabled={isLoading}
          >
            Close
          </MDButton>
          <MDButton
            onClick={() => {
              const pageNameEditor = grapeEditor.Panels.getButton("myNewPanel", "PageName");
              pageNameEditor.set(
                "label",
                `<span class="badge badge-primary" style="cursor: default;">
                            <span  class="px-2"> ${pageName}   <i class="fa fa-pencil ps-2"> </i></span>
                          </span>`
              );
              setOpenPageName(false);
              save();
            }}
            variant="contained"
            color="success"
            disabled={isLoading}
          >
            Change
          </MDButton>
          {isLoading && (
            <CircularProgress size={30} style={{ marginLeft: 15, position: "relative", top: 4 }} />
          )}
        </DialogActions>
      </Dialog>
      <Templates
        open={openTemplates}
        onClose={() => setOpenTemplates(false)}
        close={() => setOpenTemplates(false)}
        loadTemplate={(json) => {
          grapeEditor.loadProjectData(json);
          grapeEditor.UndoManager.clear();
          setOpenTemplates(false);
        }}
        loadPage={(id) => getPageById(id)}
        fullScreen
      />
      <Dialog
        open={savingOpen}
        onClose={(e, reason) => {
          if (reason === "backdropClick") return;
        }}
      >
        <DialogContent>
          <MDBox textAlign="center" style={{ backgroundcolor: "#FFF" }}>
            {isSaving && (
              <MDBox textAlign="center">
                <CircularProgress size={60} color="info" margin="10" mb="5" />
                <MDTypography> Saving ...</MDTypography>
              </MDBox>
            )}
            {loadingText != "" && (
              <MDBox>
                <MDTypography variant="h6" fontWeight="medium" color="info">
                  {loadingText}
                </MDTypography>
              </MDBox>
            )}
          </MDBox>

          {showClose && (
            <MDBox textAlign="right" style={{ backgroundcolor: "#FFF" }} mt="5">
              <MDButton
                onClick={() => {
                  setSavingOpen(false);
                  setShowClose(false);
                }}
                color="secondary"
              >
                Close
              </MDButton>
            </MDBox>
          )}
        </DialogContent>
      </Dialog>
      <Dialog
        open={isLoading}
        onClose={(e, reason) => {
          if (reason === "backdropClick") return;
        }}
      >
        <DialogContent>
          <MDBox textAlign="center" style={{ backgroundcolor: "#FFF" }}>
            {isLoading && <CircularProgress size={60} color="info" margin="10" />}
            {loadingText != "" && (
              <MDBox>
                <MDTypography variant="h6" fontWeight="medium" color="info">
                  Loading ...
                </MDTypography>
              </MDBox>
            )}
          </MDBox>
        </DialogContent>
      </Dialog>
      {settingSidebarOpen && (
        <Settingsidebar
          isLoading={isLoading}
          editor={grapeEditor}
          setSettingSidebarOpen={setSettingSidebarOpen}
          initialData={selectedPage}
          updatePageSettings={(seoTitle, seoKeyword, seoDescription, seoSlug) =>
            updateSettings(seoTitle, seoKeyword, seoDescription, seoSlug)
          }
          updatePageScripts={(
            googleConversionId,
            conversionLabel,
            googleMetaTag,
            googleAnalyticsId,
            msSiteVerificationTag,
            msUetTagId,
            headScript,
            bodyScript,
            footerScript
          ) =>
            updateScript(
              googleConversionId,
              conversionLabel,
              googleMetaTag,
              googleAnalyticsId,
              msSiteVerificationTag,
              msUetTagId,
              headScript,
              bodyScript,
              footerScript
            )
          }
          updateFavicon={(url) => {
            setFaviconUrl(url);
          }}
          updateBgImage={(url) => {
            setBgImageUrl(url);
          }}
        />
      )}
      <div id="gjs" style={{ position: "absolute", zIndex: 100, left: 0, top: 0 }}></div>
      {renderSnackBar}
    </>
  );
}

export default Page;

/*

      <Card style={{ padding: 10, height: "100%", backgroundColor: "#00044d" }}>
       
        <Grid container justifyContent="center" sx={{ my: 1 }}>
          <Grid item xs={12} lg={12} style={{ width: "100%", height: "100%" }}></Grid>
        </Grid>
      </Card>
      */
